import { VerticalAlignment } from '../../../../../common/table/CellTypeConstants';
import { TABLE_CELL_DEFAULT_VERTICAL_ALIGNMENT } from '../../../../../common/table/tableConstants';

/**
 * Maps Milanote vertical-alignment values to the Handsontable class name used in the DOM.
 */
export const getTableCellVerticalAlignmentClassName = (verticalAlignment: VerticalAlignment): string => {
    verticalAlignment = verticalAlignment || TABLE_CELL_DEFAULT_VERTICAL_ALIGNMENT;

    switch (verticalAlignment) {
        case VerticalAlignment.TOP:
            return 'htTop';
        case VerticalAlignment.MIDDLE:
            return 'htMiddle';
        case VerticalAlignment.BOTTOM:
            return 'htBottom';
    }
};
